import hanapin from "../assets/images/hanapin.png";
import emimaru from "../assets/images/emimaru.png";
import shanghaisakura from "../assets/images/shanghaisakura.png";

export const materials = [
  {
    id: 1,
    key: "a",
    image: "hiragana_a",
    title: "あ a",
    file: "hiragana_a.pdf",
    videoId: "4FTX5HUjJ6E",
    tags: ["hiragana", "single"]
  },
  {
    id: 2,
    key: "i",
    image: "hiragana_i",
    title: "い i",
    file: "hiragana_i.pdf",
    videoId: "O5xFnc2P0LY",
    tags: ["hiragana", "single"]
  },
  {
    id: 3,
    key: "u",
    image: "hiragana_u",
    title: "う u",
    file: "hiragana_u.pdf",
    videoId: "5U1ga25ESkc",
    tags: ["hiragana", "single"]
  },
  {
    id: 4,
    key: "e",
    image: "hiragana_e",
    title: "え e",
    file: "hiragana_e.pdf",
    videoId: "b61BEbZ_Jzg",
    tags: ["hiragana", "single"]
  },
  {
    id: 5,
    key: "o",
    image: "hiragana_o",
    title: "お o",
    file: "hiragana_o.pdf",
    videoId: "pOYbYH0Qn2o",
    tags: ["hiragana", "single"]
  },
  {
    id: 6,
    key: "ka",
    image: "hiragana_ka",
    title: "か ka",
    file: "hiragana_ka.pdf",
    videoId: "oxY3xFaDa-4",
    tags: ["hiragana", "single"]
  },
  {
    id: 7,
    key: "ki",
    image: "hiragana_ki",
    title: "き ki",
    file: "hiragana_ki.pdf",
    videoId: "HKpumdFVq20",
    tags: ["hiragana", "single"]
  },
  {
    id: 8,
    key: "ku",
    image: "hiragana_ku",
    title: "く ku",
    file: "hiragana_ku.pdf",
    videoId: "ISqAS5emAp8",
    tags: ["hiragana", "single"]
  },
  {
    id: 9,
    key: "ke",
    image: "hiragana_ke",
    title: "け ke",
    file: "hiragana_ke.pdf",
    videoId: "4ULH_l8Rdro",
    tags: ["hiragana", "single"]
  },
  {
    id: 10,
    key: "ko",
    image: "hiragana_ko",
    title: "こ ko",
    file: "hiragana_ko.pdf",
    videoId: "uJUG0iZ5aFQ",
    tags: ["hiragana", "single"]
  },
  {
    id: 11,
    key: "sa",
    image: "hiragana_sa",
    title: "さ sa",
    file: "hiragana_sa.pdf",
    videoId: "ZhXsUIpuZe8",
    tags: ["hiragana", "single"]
  },
  {
    id: 12,
    key: "shi",
    image: "hiragana_shi",
    title: "し shi",
    file: "hiragana_shi.pdf",
    videoId: "ghi2Xx5cFTE",
    tags: ["hiragana", "single"]
  },
  {
    id: 13,
    key: "su",
    image: "hiragana_su",
    title: "す su",
    file: "hiragana_su.pdf",
    videoId: "Wq_jAUid9_c",
    tags: ["hiragana", "single"]
  },
  {
    id: 14,
    key: "se",
    image: "hiragana_se",
    title: "せ se",
    file: "hiragana_se.pdf",
    videoId: "nLT6nRSs6t8",
    tags: ["hiragana", "single"]
  },
  {
    id: 15,
    key: "so",
    image: "hiragana_so",
    title: "そ so",
    file: "hiragana_so.pdf",
    videoId: "FJbtBU4MW8s",
    tags: ["hiragana", "single"]
  },
  {
    id: 16,
    key: "ta",
    image: "hiragana_ta",
    title: "た ta",
    file: "hiragana_ta.pdf",
    videoId: "Yhs7RlVKsds",
    tags: ["hiragana", "single"]
  },
  {
    id: 17,
    key: "chi",
    image: "hiragana_chi",
    title: "ち chi",
    file: "hiragana_chi.pdf",
    videoId: "s2HQ7eypY8s",
    tags: ["hiragana", "single"]
  },
  {
    id: 18,
    key: "tsu",
    image: "hiragana_tsu",
    title: "つ tsu",
    file: "hiragana_tsu.pdf",
    videoId: "HK0v1ZDdTp4",
    tags: ["hiragana", "single"]
  },
  {
    id: 19,
    key: "te",
    image: "hiragana_te",
    title: "て te",
    file: "hiragana_te.pdf",
    videoId: "5CI_xtF7kbs",
    tags: ["hiragana", "single"]
  },
  {
    id: 20,
    key: "to",
    image: "hiragana_to",
    title: "と to",
    file: "hiragana_to.pdf",
    videoId: "YIMFviKNp3Q",
    tags: ["hiragana", "single"]
  },
  {
    id: 21,
    key: "na",
    image: "hiragana_na",
    title: "な na",
    file: "hiragana_na.pdf",
    videoId: "_qizYrQvAK8",
    tags: ["hiragana", "single"]
  },
  {
    id: 22,
    key: "ni",
    image: "hiragana_ni",
    title: "に ni",
    file: "hiragana_ni.pdf",
    videoId: "aCwglYaQrL8",
    tags: ["hiragana", "single"]
  },
  {
    id: 23,
    key: "nu",
    image: "hiragana_nu",
    title: "ぬ nu",
    file: "hiragana_nu.pdf",
    videoId: "HG4LPzNBALY",
    tags: ["hiragana", "single"]
  },
  {
    id: 24,
    key: "ne",
    image: "hiragana_ne",
    title: "ね ne",
    file: "hiragana_ne.pdf",
    videoId: "xzdTVHG9lbg",
    tags: ["hiragana", "single"]
  },
  {
    id: 25,
    key: "no",
    image: "hiragana_no",
    title: "の no",
    file: "hiragana_no.pdf",
    videoId: "W3dUzdPC94Y",
    tags: ["hiragana", "single"]
  },
  {
    id: 26,
    key: "ha",
    image: "hiragana_ha",
    title: "は ha",
    file: "hiragana_ha.pdf",
    videoId: "QO_aL_uE5UA",
    tags: ["hiragana", "single"]
  },
  {
    id: 27,
    key: "hi",
    image: "hiragana_hi",
    title: "ひ hi",
    file: "hiragana_hi.pdf",
    videoId: "Hs1gnvCSiJk",
    tags: ["hiragana", "single"]
  },
  {
    id: 28,
    key: "fu",
    image: "hiragana_fu",
    title: "ふ fu",
    file: "hiragana_fu.pdf",
    videoId: "UFmBUpkgNsk",
    tags: ["hiragana", "single"]
  },
  {
    id: 29,
    key: "he",
    image: "hiragana_he",
    title: "へ he",
    file: "hiragana_he.pdf",
    videoId: "ybziSw6qy6Y",
    tags: ["hiragana", "single"]
  },
  {
    id: 30,
    key: "ho",
    image: "hiragana_ho",
    title: "ほ ho",
    file: "hiragana_ho.pdf",
    videoId: "qPRMCza6Iv0",
    tags: ["hiragana", "single"]
  },
  {
    id: 31,
    key: "ma",
    image: "hiragana_ma",
    title: "ま ma",
    file: "hiragana_ma.pdf",
    videoId: "rxgsRuokSO0",
    tags: ["hiragana", "single"]
  },
  {
    id: 32,
    key: "mi",
    image: "hiragana_mi",
    title: "み mi",
    file: "hiragana_mi.pdf",
    videoId: "n8M_zG0EvZQ",
    tags: ["hiragana", "single"]
  },
  {
    id: 33,
    key: "mu",
    image: "hiragana_mu",
    title: "む mu",
    file: "hiragana_mu.pdf",
    videoId: "SreDcqwKHw4",
    tags: ["hiragana", "single"]
  },
  {
    id: 34,
    key: "me",
    image: "hiragana_me",
    title: "め me",
    file: "hiragana_me.pdf",
    videoId: "JaHMxKg9CeU",
    tags: ["hiragana", "single"]
  },
  {
    id: 35,
    key: "mo",
    image: "hiragana_mo",
    title: "も mo",
    file: "hiragana_mo.pdf",
    videoId: "7Di7G_Jbl2g",
    tags: ["hiragana", "single"]
  },
  {
    id: 36,
    key: "ya",
    image: "hiragana_ya",
    title: "や ya",
    file: "hiragana_ya.pdf",
    videoId: "TWt3LSmMgZA",
    tags: ["hiragana", "single"]
  },
  {
    id: 37,
    key: "yu",
    image: "hiragana_yu",
    title: "ゆ yu",
    file: "hiragana_yu.pdf",
    videoId: "jnC9QzhlH_M",
    tags: ["hiragana", "single"]
  },
  {
    id: 38,
    key: "yo",
    image: "hiragana_yo",
    title: "よ yo",
    file: "hiragana_yo.pdf",
    videoId: "8FSv1bZlzCg",
    tags: ["hiragana", "single"]
  },
  {
    id: 39,
    key: "ra",
    image: "hiragana_ra",
    title: "ら ra",
    file: "hiragana_ra.pdf",
    videoId: "beoMyX6i8S8",
    tags: ["hiragana", "single"]
  },
  {
    id: 40,
    key: "ri",
    image: "hiragana_ri",
    title: "り ri",
    file: "hiragana_ri.pdf",
    videoId: "gjx-91G1uNU",
    tags: ["hiragana", "single"]
  },
  {
    id: 41,
    key: "ru",
    image: "hiragana_ru",
    title: "る ru",
    file: "hiragana_ru.pdf",
    videoId: "FX6yAsdXAFc",
    tags: ["hiragana", "single"]
  },
  {
    id: 42,
    key: "re",
    image: "hiragana_re",
    title: "れ re",
    file: "hiragana_re.pdf",
    videoId: "QITqSPCEcE4",
    tags: ["hiragana", "single"]
  },
  {
    id: 43,
    key: "ro",
    image: "hiragana_ro",
    title: "ろ ro",
    file: "hiragana_ro.pdf",
    videoId: "FX6yAsdXAFc",
    tags: ["hiragana", "single"]
  },
  {
    id: 44,
    key: "wa",
    image: "hiragana_wa",
    title: "わ wa",
    file: "hiragana_wa.pdf",
    videoId: "_W5NJEauqbk",
    tags: ["hiragana", "single"]
  },
  {
    id: 45,
    key: "wo",
    image: "hiragana_wo",
    title: "を o",
    file: "hiragana_wo.pdf",
    videoId: "aEfw-PEAzB4",
    tags: ["hiragana", "single"]
  },
  {
    id: 46,
    key: "n",
    image: "hiragana_n",
    title: "ん n",
    file: "hiragana_n.pdf",
    videoId: "j7uo5Et1JYU",
    tags: ["hiragana", "single"]
  },
  {
    id: 47,
    key: "ga",
    image: "hiragana_ga",
    title: "が ga",
    file: "hiragana_ga.pdf",
    videoId: "MxJCy5zBETw",
    tags: ["hiragana", "single"]
  },
  {
    id: 48,
    key: "gi",
    image: "hiragana_gi",
    title: "ぎ gi",
    file: "hiragana_gi.pdf",
    videoId: "GlkKu2g5rws",
    tags: ["hiragana", "single"]
  },
  {
    id: 49,
    key: "gu",
    image: "hiragana_gu",
    title: "ぐ gu",
    file: "hiragana_gu.pdf",
    videoId: "EtXGOx_0d5A",
    tags: ["hiragana", "single"]
  },
  {
    id: 50,
    key: "ge",
    image: "hiragana_ge",
    title: "げ ge",
    file: "hiragana_ge.pdf",
    videoId: "DXC42EQx5bE",
    tags: ["hiragana", "single"]
  },
  {
    id: 51,
    key: "go",
    image: "hiragana_go",
    title: "ご go",
    file: "hiragana_go.pdf",
    videoId: "sSlUVgYxue8",
    tags: ["hiragana", "single"]
  },
  {
    id: 52,
    key: "za",
    image: "hiragana_za",
    title: "ざ za",
    file: "hiragana_za.pdf",
    videoId: "20E9A4F_XOQ",
    tags: ["hiragana", "single"]
  },
  {
    id: 53,
    key: "ji",
    image: "hiragana_ji",
    title: "じ ji",
    file: "hiragana_ji.pdf",
    videoId: "O5xFnc2P0LY",
    tags: ["hiragana", "single"]
  },
  {
    id: 54,
    key: "zu",
    image: "hiragana_zu",
    title: "ず zu",
    file: "hiragana_zu.pdf",
    videoId: "5U1ga25ESkc",
    tags: ["hiragana", "single"]
  },
  {
    id: 55,
    key: "ze",
    image: "hiragana_ze",
    title: "ぜ ze",
    file: "hiragana_ze.pdf",
    videoId: "zFnRRgDxf5U",
    tags: ["hiragana", "single"]
  },
  {
    id: 56,
    key: "zo",
    image: "hiragana_zo",
    title: "ぞ zo",
    file: "hiragana_zo.pdf",
    videoId: "bm4IxDOJIi8",
    tags: ["hiragana", "single"]
  },
  {
    id: 57,
    key: "da",
    image: "hiragana_da",
    title: "だ da",
    file: "hiragana_da.pdf",
    videoId: "EgsBJjzu4So",
    tags: ["hiragana", "single"]
  },
  {
    id: 58,
    key: "di",
    image: "hiragana_di",
    title: "ぢ ji",
    file: "hiragana_di.pdf",
    videoId: "HPXhroCoIjE",
    tags: ["hiragana", "single"]
  },
  {
    id: 59,
    key: "du",
    image: "hiragana_du",
    title: "づ zu",
    file: "hiragana_du.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 60,
    key: "de",
    image: "hiragana_de",
    title: "で de",
    file: "hiragana_de.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 61,
    key: "do",
    image: "hiragana_do",
    title: "ど do",
    file: "hiragana_do.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 62,
    key: "ba",
    image: "hiragana_ba",
    title: "ば ba",
    file: "hiragana_ba.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 63,
    key: "bi",
    image: "hiragana_bi",
    title: "び bi",
    file: "hiragana_bi.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 64,
    key: "bu",
    image: "hiragana_bu",
    title: "ぶ bu",
    file: "hiragana_bu.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 65,
    key: "be",
    image: "hiragana_be",
    title: "べ be",
    file: "hiragana_be.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 66,
    key: "bo",
    image: "hiragana_bo",
    title: "ぼ bo",
    file: "hiragana_bo.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 67,
    key: "pa",
    image: "hiragana_pa",
    title: "ぱ pa",
    file: "hiragana_pa.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 68,
    key: "pi",
    image: "hiragana_pi",
    title: "ぴ pi",
    file: "hiragana_pi.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 69,
    key: "pu",
    image: "hiragana_pu",
    title: "ぷ pu",
    file: "hiragana_pu.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 70,
    key: "pe",
    image: "hiragana_pe",
    title: "ぺ pe",
    file: "hiragana_pe.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 71,
    key: "po",
    image: "hiragana_po",
    title: "ぽ po",
    file: "hiragana_po.pdf",
    videoId: "",
    tags: ["hiragana", "single"]
  },
  {
    id: 73,
    key: "all_1",
    image: "Complete Hiragana Stroke Order Practice Tracing Sheet",
    title: "【Lv.1】なぞっておぼえるひらがな（かきじゅんつき） Hiragana Stroke Order Practice Tracing Sheet 按笔顺描平假名",
    file: "Complete Hiragana Stroke Order Practice Tracing Sheet.pdf",
    videoId: "FLz6NAqRVPo",
    tags: ["hiragana", "all", "cheat-sheet-test"]
  },
  {
    id: 74,
    key: "all_2",
    image: "Complete Hiragana Practice Tracing Sheet",
    title: "【Lv.2】 なぞっておぼえるひらがな Hiragana Practice Tracing Sheet 平假名描红练习",
    file: "Complete Hiragana Practice Tracing Sheet.pdf",
    videoId: "FLz6NAqRVPo",
    tags: ["hiragana", "all", "cheat-sheet-test"]
  },
  {
    id: 75,
    key: "all_3",
    image: "Complete Hiragana Practice Writing Sheet (Blank)",
    title: "【Lv.3】はくしにかけるかな？ひらがなてすと Hiragana Writing Review Sheet (Blank) 平假名书写复习（空白）",
    file: "Complete Hiragana Practice Writing Sheet (Blank).pdf",
    videoId: "FLz6NAqRVPo",
    tags: ["hiragana", "all", "cheat-sheet-test"]
  },
  {
    id: 76,
    key: "blank_paper",
    image: "Hiragana Katakana Kanji Blank Practice Sheet",
    title: "【Blank Sheet】はくしれんしゅうよう Blank Practice Sheet 空白练习纸",
    file: "Hiragana Katakana Kanji Blank Practice Sheet.pdf",
    videoId: "",
    tags: ["hiragana", "katakana", "all", "cheat-sheet-test"],
  },
  {
    id: 77,
    key: "all_4",
    image: "【あいうえおかきくけこ】T2W5(1)",
    title: "【あいうえおかきくけこ】2もじなぞって5もじかこう Trace 2, Write 5 先描2个，再写5个(1)",
    file: "【あいうえおかきくけこ】T2W5(1).pdf",
    videoId: "",
    tags: ["hiragana", "all"]
  },
  {
    id: 78,
    key: "all_5",
    image: "【さしすせそたちつてと】T2W5(2)",
    title: "【さしすせそたちつてと】2もじなぞって5もじかこう Trace 2, Write 5 先描2个，再写5个(2)",
    file: "【さしすせそたちつてと】T2W5(2).pdf",
    videoId: "",
    tags: ["hiragana", "all"]
  },
  {
    id: 79,
    key: "all_6",
    image: "【なにぬねのははひふへほ】T2W5(3)",
    title: "【なにぬねのははひふへほ】2もじなぞって5もじかこう Trace 2, Write 5 先描2个，再写5个(3)",
    file: "【なにぬねのははひふへほ】T2W5(3).pdf",
    videoId: "",
    tags: ["hiragana", "all"]
  },
  {
    id: 80,
    key: "all_7",
    image: "【まみむめもやゆよ】T2W5(4)",
    title: "【まみむめもやゆよ】2もじなぞって5もじかこう Trace 2, Write 5 先描2个，再写5个(4)",
    file: "【まみむめもやゆよ】T2W5(4).pdf",
    videoId: "",
    tags: ["hiragana", "all"]
  },
  {
    id: 81,
    key: "all_8",
    image: "【らりるれろわをん】T2W5(5)",
    title: "【らりるれろわをん】2もじなぞって5もじかこう Trace 2, Write 5 先描2个，再写5个(5)",
    file: "【らりるれろわをん】T2W5(5).pdf",
    videoId: "",
    tags: ["hiragana", "all"]
  },
  {
    id: 82,
    key: "all_9",
    image: "【がぎぐげござじずぜぞ】T2W5(6)",
    title: "【がぎぐげござじずぜぞ】2もじなぞって5もじかこう Trace 2, Write 5 先描2个，再写5个(6)",
    file: "【がぎぐげござじずぜぞ】T2W5(6).pdf",
    videoId: "",
    tags: ["hiragana", "all"]
  },
  {
    id: 83,
    key: "all_10",
    image: "【だぢづでどばびぶべぼ】T2W5(7)",
    title: "【だぢづでどばびぶべぼ】2もじなぞって5もじかこう Trace 2, Write 5 先描2个，再写5个(7)",
    file: "【だぢづでどばびぶべぼ】T2W5(7).pdf",
    videoId: "",
    tags: ["hiragana", "all"]
  },
  {
    id: 84,
    key: "all_11",
    image: "【ぱぴぷぺぽ】T2W5(8)",
    title: "【ぱぴぷぺぽ】2もじなぞって5もじかこう Trace 2, Write 5 先描2个，再写5个(8)",
    file: "【ぱぴぷぺぽ】T2W5(8).pdf",
    videoId: "",
    tags: ["hiragana", "all"]
  },
  {
    id: 0,
    key: "all_12",
    image: "Hiragana Character Chart",
    title: "【Cheat Sheet】ひらがないちらんひょう Hiragana Character Chart 平假名表",
    file: "Hiragana Character Chart.pdf",
    videoId: "",
    tags: ["hiragana", "all", "cheat-sheet-test"]
  },
  {
    id: 72,
    key: "all_13",
    image: "Katakana Character Chart",
    title: "【Cheat Sheet】カタカナいちらんひょう Katakana Character Chart 片假名表",
    file: "Katakana Character Chart.pdf",
    videoId: "",
    tags: ["katakana", "all", "cheat-sheet-test"]
  },
  {
    id: 85,
    key: "grid_1",
    image: "Vertical Writing Sheet 6_9 Squares With Dashed Guides",
    title: "【A4 Blank Goodnotes】こくごノート（6×9) Japanese Writing Notebook With Dashed Guides 日语书写练习本 附虚线辅助",
    file: "Vertical Writing Sheet 6_9 Squares With Dashed Guides.pdf",
    videoId: "",
    tags: ["hiragana", "katakana", "all", "cheat-sheet-test"]
  },
  {
    id: 86,
    key: "grid_2",
    image: "Vertical Writing 12_18 Grid",
    title: "【A4 Blank Goodnotes】こくごノート（12×18) Japanese Writing Notebook 日语书写练习本",
    file: "Vertical Writing 12_18 Grid.pdf",
    videoId: "",
    tags: ["hiragana", "katakana", "all", "cheat-sheet-test"]
  },
  {
    id: 87,
    key: "grid_3",
    image: "Vertical Writing 9_6 Grid With Dashed Guides",
    title: "【A4 Blank Goodnotes】こくごノート（9×6) Japanese Writing Notebook With Dashed Guides 日语书写练习本 附虚线辅助",
    file: "Vertical Writing 9_6 Grid With Dashed Guides.pdf",
    videoId: "",
    tags: ["hiragana", "katakana", "all", "cheat-sheet-test"]
  },
  {
    id: 88,
    key: "grid_4",
    image: "Vertical Writing 18_12 Grid",
    title: "【A4 Blank Goodnotes】こくごノート（18×12) Japanese Writing Notebook 日语书写练习本",
    file: "Vertical Writing 18_12 Grid.pdf",
    videoId: "",
    tags: ["hiragana", "katakana", "all", "cheat-sheet-test"]
  },
  {
    id: 89,
    key: "all_14",
    image: "Complete Katakana Stroke Order Practice Tracing Sheet",
    title: "【Lv.1】なぞっておぼえるカタカナ（かきじゅんつき） Katakana Stroke Order Practice Tracing Sheet 按笔顺描片假名",
    file: "Complete Katakana Stroke Order Practice Tracing Sheet.pdf",
    videoId: "0J_N3UDUIXk",
    tags: ["katakana", "all", "cheat-sheet-test"]
  },
  {
    id: 90,
    key: "all_15",
    image: "Complete Katakana Practice Tracing Sheet",
    title: "【Lv.2】 なぞっておぼえるカタカナ Katakana Practice Tracing Sheet 片假名描红练习",
    file: "Complete Katakana Practice Tracing Sheet.pdf",
    videoId: "0J_N3UDUIXk",
    tags: ["katakana", "all", "cheat-sheet-test"]
  },
  {
    id: 91,
    key: "all_16",
    image: "Complete Katakana Practice Writing Sheet (Blank)",
    title: "【Lv.3】はくしにかけるかな？カタカナてすと Katakana Writing Review Sheet (Blank) 片假名书写复习（空白）",
    file: "Complete Katakana Practice Writing Sheet (Blank).pdf",
    videoId: "0J_N3UDUIXk",
    tags: ["katakana", "all", "cheat-sheet-test"]
  }
];
